export const DEBT_RATIO_UNIT = 10000000000000000000;
export const MAX_PAGE = 1000;
export const TRADING_VIEW_RERENDER_INTERVAL = 300;
export const TRADING_VIEW_MAX_NUM_OF_RERENDERS = 20;
